import { useKeyPress } from 'ahooks'
import { notification } from 'components/common'
import { appVersion } from 'config'

export const AppVersion = (): JSX.Element => {
  useKeyPress('ctrl.alt.v', () => {
    notification.open({
      message: 'Version',
      description: appVersion,
    })
  })

  return <></>
}
